export default __webpack_public_path__ + "static/media/arrow.91e49823.png";